import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://doflkphikufhrgsquyif.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvZmxrcGhpa3VmaHJnc3F1eWlmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg1OTYyMDUsImV4cCI6MjA4NDE3MjIwNX0.hz7HVamVsflLXDukdkcFEfWS95Bf8MAMPF76fvTUwjs';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    storageKey: 'loaddrive-auth',
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Clear session when browser closes (not tab, full browser)
window.addEventListener('beforeunload', () => {
  const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
  if (nav?.type !== 'reload') {
    sessionStorage.setItem('loaddrive-browser-open', 'true');
  }
});

// On load, check if this is a fresh browser open
if (!sessionStorage.getItem('loaddrive-browser-open')) {
  localStorage.removeItem('loaddrive-auth');
}
sessionStorage.setItem('loaddrive-browser-open', 'true');